import { Type } from "@sinclair/typebox";
import { Sha256Schema, TimestampSchema } from "./shared.js";
const count = Type.Integer({ minimum: 0, maximum: Number.MAX_SAFE_INTEGER });
const ratio = Type.Union([Type.Number({ minimum: 0, maximum: 1 }), Type.Null()]);
export const ModelCacheUsageMetricsSchema = Type.Object({
    requests: count,
    closedRequests: count,
    pendingRequests: count,
    usageKnownRequests: count,
    cacheKnownRequests: count,
    zeroHitRequests: count,
    unknownUsageRequests: count,
    knownInputTokens: count,
    cacheKnownInputTokens: count,
    cachedInputTokens: count,
    outputTokens: count,
    hitRatio: ratio,
    requestCoverage: ratio,
    inputTokenCoverage: ratio,
}, { additionalProperties: false });
export const ModelCacheUsageQuerySchema = Type.Object({
    from: Type.Optional(TimestampSchema),
    to: Type.Optional(TimestampSchema),
}, { additionalProperties: false });
export const ModelCacheUsageSnapshotSchema = Type.Object({
    source: Type.Literal("model_upstream_observed"),
    from: TimestampSchema,
    to: TimestampSchema,
    observedFrom: Type.Union([TimestampSchema, Type.Null()]),
    totals: ModelCacheUsageMetricsSchema,
    groups: Type.Array(Type.Object({
        adapter: Type.Union([Type.Literal("codex"), Type.Literal("responses")]),
        modelConfigDigest: Sha256Schema,
        modelName: Type.String({ minLength: 1 }),
        phase: Type.Union([
            Type.Literal("task"),
            Type.Literal("arguments"),
            Type.Literal("title"),
            Type.Literal("report"),
        ]),
        role: Type.Union([
            Type.Literal("planner"),
            Type.Literal("worker"),
            Type.Literal("vision"),
        ]),
        ...ModelCacheUsageMetricsSchema.properties,
    }, { additionalProperties: false })),
}, { additionalProperties: false });
//# sourceMappingURL=model-cache.js.map